module.exports = __webpack_public_path__ + "img/logo-mobile-for-animation.1a7cf72036eaf6a337ec5f9d0d4cc932.svg";